/**
 * Display-only discount helpers (percentage and/or fixed dollar amount).
 * Does not affect cart/checkout — real discounts must use Shopify Automatic Discounts / Functions.
 *
 * Matching Liquid:
 *   amount wins when > 0: sale = cents - round(amountDollars * 100)
 *   else percent: sale = cents - round(cents * pct / 100)
 */
(function (window) {
  'use strict';

  function parseDiscountPercent(value) {
    var n = parseFloat(value);
    if (isNaN(n) || n <= 0) return 0;
    return n;
  }

  function parseDiscountAmount(value) {
    var n = parseFloat(value);
    if (isNaN(n) || n <= 0) return 0;
    return n;
  }

  function getDiscountPercentFromElement(el) {
    if (!el) return 0;
    return parseDiscountPercent(el.getAttribute('data-discount-percentage'));
  }

  function getDiscountAmountFromElement(el) {
    if (!el) return 0;
    return parseDiscountAmount(el.getAttribute('data-discount-amount'));
  }

  function getDiscountPercentFromContainer(root) {
    var scope = root || document;
    var el =
      scope.querySelector('[data-discount-percentage]') ||
      document.querySelector('#custom-product-container .price[data-discount-percentage]') ||
      document.querySelector('.price[data-discount-percentage]') ||
      document.querySelector('.suave-dp-price[data-discount-percentage]');
    return getDiscountPercentFromElement(el);
  }

  function getDiscountAmountFromContainer(root) {
    var scope = root || document;
    var el =
      scope.querySelector('[data-discount-amount]') ||
      document.querySelector('#custom-product-container .price[data-discount-amount]') ||
      document.querySelector('.price[data-discount-amount]') ||
      document.querySelector('.suave-dp-price[data-discount-amount]');
    return getDiscountAmountFromElement(el);
  }

  /** Apply display discount to a price in cents. Returns cents (integer). */
  function applyDisplayDiscountCents(cents, percent, amountDollars) {
    var c = Math.round(Number(cents) || 0);
    if (c <= 0) return c;
    var amt = parseDiscountAmount(amountDollars);
    if (amt > 0) {
      return Math.max(0, c - Math.round(amt * 100));
    }
    var p = parseDiscountPercent(percent);
    if (!(p > 0)) return c;
    var discountAmount = Math.round((c * p) / 100);
    return Math.max(0, c - discountAmount);
  }

  /**
   * Resolve display sale + compare-at cents for a variant.
   * Amount wins over percent when both are set.
   * When a metafield discount applies: compare = original variant price.
   */
  function resolveDisplayPrices(variantPriceCents, compareAtCents, percent, amountDollars) {
    var price = Math.round(Number(variantPriceCents) || 0);
    var compare = compareAtCents != null && compareAtCents !== '' ? Math.round(Number(compareAtCents) || 0) : 0;
    var amt = parseDiscountAmount(amountDollars);
    var p = parseDiscountPercent(percent);

    if (amt > 0 || p > 0) {
      var saleCents = applyDisplayDiscountCents(price, p, amt);
      return {
        saleCents: saleCents,
        compareCents: price > saleCents ? price : null,
        hasDiscount: true,
        discountAmountDollars: amt > 0 ? amt : 0,
        discountPercentage: amt > 0 ? 0 : p
      };
    }

    return {
      saleCents: price,
      compareCents: compare > price ? compare : null,
      hasDiscount: false,
      discountAmountDollars: 0,
      discountPercentage: 0
    };
  }

  function formatMoney(cents) {
    var centsInt = Math.round(Number(cents) || 0);
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      var fmt =
        (window.theme && window.theme.moneyFormat) ||
        (typeof Shopify.money_format !== 'undefined' && Shopify.money_format) ||
        '${{amount}}';
      return Shopify.formatMoney(centsInt, fmt);
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(centsInt / 100);
  }

  window.SuaveDisplayDiscount = {
    parsePercent: parseDiscountPercent,
    parseAmount: parseDiscountAmount,
    getPercentFromElement: getDiscountPercentFromElement,
    getAmountFromElement: getDiscountAmountFromElement,
    getPercentFromContainer: getDiscountPercentFromContainer,
    getAmountFromContainer: getDiscountAmountFromContainer,
    applyCents: applyDisplayDiscountCents,
    resolvePrices: resolveDisplayPrices,
    formatMoney: formatMoney
  };
})(window);
